import { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import InquiryForm from "@/components/InquiryForm";
import { publicApi } from "@/lib/api";

export default function Contact() {
  const { t } = useLanguage();
  const [cfg, setCfg] = useState({ email: "", whatsapp: "" });

  useEffect(() => {
    publicApi.config().then(setCfg).catch(() => {});
  }, []);

  return (
    <div className="pt-32 pb-24">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="overline mb-3">{t("contact.label")}</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight text-ink font-light max-w-3xl">
          {t("contact.title")}
        </h1>

        <div className="mt-16 grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5 space-y-8">
            {cfg.email && (
              <div>
                <div className="overline mb-2">Email</div>
                <a
                  data-testid="contact-email-link"
                  href={`mailto:${cfg.email}`}
                  className="font-serif text-2xl text-ink hover:text-accent transition-colors"
                >
                  {cfg.email}
                </a>
              </div>
            )}
            {cfg.whatsapp && (
              <div>
                <div className="overline mb-2">WhatsApp</div>
                <a
                  data-testid="contact-whatsapp-link"
                  href={`https://wa.me/${cfg.whatsapp}?text=${encodeURIComponent(t("contact.whatsapp_prefill"))}`}
                  target="_blank"
                  rel="noreferrer"
                  className="font-serif text-2xl text-ink hover:text-accent transition-colors"
                >
                  +{cfg.whatsapp}
                </a>
              </div>
            )}
            <div>
              <div className="overline mb-2">{t("contact_page.office")}</div>
              <div className="font-serif text-2xl text-ink leading-tight whitespace-pre-line">
                {t("contact_page.office_addr")}
              </div>
            </div>
          </div>
          <div className="md:col-span-7">
            <InquiryForm testIdPrefix="contact-inquiry" />
          </div>
        </div>
      </div>
    </div>
  );
}
